var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full overflow-hidden",attrs:{"id":"app"}},[_c('Loading',{attrs:{"active":_vm.isLoading}}),(_vm.isLoginReady)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }